// extracted by mini-css-extract-plugin
module.exports = {"icon":"_149Xkqdf","isSmall":"_1P4TZHrL","isMedium":"_14da9MMz","isLarge":"z3C4uKd_","isXLarge":"_1XK7-o77","isXXLarge":"_37CFQW_9"};